export default __webpack_public_path__ + "static/media/027aea6620a68921c58c05b64e02f28e.svg";